export const versao = "1.0.0.3";

export default versao;